import request from '@/request'
// 首次进入
export const firstJoin = (data) => {
  return request({
    url: '/exterior_intFtuCarnivalStamp_Vipwd/firstJoin.action',
    method: 'post',
    data,
    isMd5: true
  })
}
// 首页详情
export const homePage = (data) => {
  return request({
    url: '/exterior_intFtuCarnivalStamp_Vipwd/homePage.action',
    method: 'post',
    data,
    isMd5: true
  })
}
// 邮票获取
export const stampGet = (data) => {
  return request({
    url: '/exterior_intFtuCarnivalStamp_Vipwd/stampGet.action',
    method: 'post',
    data,
    isMd5: true
  })
}
// 邮票支出
export const stampPay = (data) => {
  return request({
    url: '/exterior_intFtuCarnivalStamp_Vipwd/stampPay.action',
    method: 'post',
    data,
    isMd5: true
  })
}
// 邮票明细
export const stampDetail = (data) => {
  return request({
    url: '/exterior_intFtuCarnivalStamp_Vipwd/stampDetail.action',
    method: 'post',
    data,
    isMd5: true
  })
}
export const getOrderView = (data) => {
  return request({
    url: '/integral_order/orderview.action',
    method: 'post',
    isMd5: true,
    data
  })
}

// 确认收货
export const receipt = (data) => {
  return request({
    url: '/exterior_intFtuProductLogisticsinfo/receipt.action',
    method: 'post',
    data: data,
    isMd5: false
  })
}
// 商品列表
export const getProduct = (data) => {
  return request({
    url: '/exterior_intFtuYpProduct_Vipwd/getProduct.action',
    method: 'post',
    data: data,
    isMd5: true
  })
}
// 商品详情
export const getProductDetail = (data) => {
  return request({
    url: '/exterior_intFtuYpProduct_Vipwd/getProductDetail.action',
    method: 'post',
    data: data,
    isMd5: true
  })
}
// 商品兑换
export const change = (data) => {
  return request({
    url: '/exterior_ypExchange_Vipwd/change.action',
    method: 'post',
    data: data,
    isMd5: true
  })
}

export const getOrderList = (data) => {
  return request({
    url: '/integral_order/orderlist.action',
    method: 'post',
    isMd5: true,
    data
  })
}
export const viewLogistics = (data) => {
  return request({
    url: '/exterior_intFtuProductLogisticsinfo/viewLogistics.action',
    method: 'post',
    isMd5: false,
    data
  })
}
// 查询快递公司名称
export const viewCompany = (data) => {
  return request({
    url: '/exterior_intFtuProductLogisticsinfo/viewCompany.action',
    method: 'post',
    isMd5: false,
    data
  })
}
// 查询物流公司编码
export const viewexpressName = (data) => {
  return request({
    url: '/exterior_intFtuProductLogisticsinfo/viewexpressName.action',
    method: 'post',
    isMd5: false,
    data
  })
}
